import { MapPin, Phone, MessageCircle, ExternalLink } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/constants";
import LocationHours from "@/components/site/LocationHours";

const Location = () => {
  const { t } = useLanguage();
  return (
    <section id="location" className="relative py-20 md:py-28" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-8 items-stretch">
          <div className="lg:col-span-2 flex flex-col gap-6">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
                <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
                {t.location.eyebrow}
              </div>
              <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tight">
                {t.location.title}
              </h2>
              <p className="mt-3 text-white/60 inline-flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#e10600]" /> {t.location.subtitle}
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href={BRAND.mapsLink}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#e10600] hover:bg-[#c20500] text-white font-bold transition"
                  data-testid="location-maps-btn"
                >
                  <ExternalLink className="w-4 h-4" />
                  {t.common.openInGoogleMaps}
                </a>
                <a
                  href={BRAND.whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 hover:bg-white/5 text-white font-bold transition"
                  data-testid="location-whatsapp-btn"
                >
                  <MessageCircle className="w-4 h-4" />
                  {t.common.whatsappNow}
                </a>
                <a
                  href={BRAND.telLink}
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 hover:bg-white/5 text-white font-bold transition"
                  data-testid="location-call-btn"
                >
                  <Phone className="w-4 h-4" />
                  {t.common.callNow}
                </a>
              </div>
            </div>

            <LocationHours />
          </div>

          <div className="lg:col-span-3">
            <div
              className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[16/11] bg-[#111] lg:h-full"
              data-testid="location-map"
            >
              <iframe
                title="Dent Xpress Shuwaikh Kuwait"
                src={BRAND.mapsEmbed}
                className="absolute inset-0 w-full h-full grayscale contrast-125 opacity-90"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-white/5" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
